/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


  // Add custom code below this line

(function() {
  document.querySelectorAll(".glb_mute").forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentDiv = btn.parentElement; // find nearest parent div
      const currentVideo = parentDiv.querySelector("video");
      if (currentVideo && !currentVideo.paused) {
        document.querySelectorAll(".off_sound_global, .video_selector").forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector('.glb_play');
          const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
          if (video !== currentVideo && !video.paused) {
            video.muted = true;
            //video.pause();
            const parentDivELe = video.parentElement;
            const muteBtn = parentDivELe.querySelector(".glb_mute");
            if (muteBtn) {
              muteBtn.classList.add("muted");
            }
          }
        });
      }
    });
  });
  function offsoundAllVideos(currentWrapper = null) {
    const isMobile = window.innerWidth <= 767;
    const allOtherVideos = document.querySelectorAll('.off_sound_global');

    allOtherVideos.forEach((wrapper) => {
      // Skip the current (active) video
      if (currentWrapper && wrapper === currentWrapper) return;

      const video = wrapper.querySelector("video");
      const playBtn = wrapper.querySelector('.glb_play');
      const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const muteBtn = wrapper.querySelector(".glb_mute");

      if (!video) return;

      // Pause and mute all other videos
      video.pause();
      video.muted = true;

      // Reset UI states
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
      if (muteBtn) muteBtn.classList.add('muted');
    });
  }
  function safePlayUsingFlickity( section, videoWrapper )
  {
    //offsoundAllVideos(videoWrapper);
    const playBtn = videoWrapper.querySelector('.glb_play');
    const video = videoWrapper.querySelector('video');
    const videoPoster = videoWrapper.querySelector(".custom-poster-wrapper");

    const carousel = section.querySelector('.customer-love-it__slider');
    const flkty = window.theme.Flickity.data(carousel);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        playBtn?.classList.add('playing');
        video.onended = () => {
          video.pause();
          playBtn?.classList.remove('playing');
          if (videoPoster) videoPoster.style.opacity = 1;
          if (flkty) flkty.next();
        };
      })
      .catch(() => {
        playBtn?.classList.remove('playing');
        if (videoPoster) videoPoster.style.opacity = 1;
      });
    }
  }
  function initCustomerLoverItHlsVideo(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.customer_love_it_video');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    // ✅ Progress bar helper
    function attachVideoProgress(video, wrapper) {
      let progressBar = wrapper.querySelector('.video-progress-bar');
      if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'video-progress-bar';
        Object.assign(progressBar.style, {
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          width: 'calc(100% - 20px)',
          height: '4px',
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '2px',
          overflow: 'hidden',
          zIndex: 3,
        });

        const progressFill = document.createElement('div');
        progressFill.className = 'video-progress-fill';
        Object.assign(progressFill.style, {
          width: '0%',
          height: '100%',
          background: '#fff',
          transition: 'width 0.2s linear',
        });

        progressBar.appendChild(progressFill);
        wrapper.appendChild(progressBar);
      }

      const progressFill = progressBar.querySelector('.video-progress-fill');
      let rafId = null;

      function updateProgress() {
        if (!video.paused && !video.ended && video.duration > 0) {
          const percent = (video.currentTime / video.duration) * 100;
          progressFill.style.width = `${percent}%`;
          rafId = requestAnimationFrame(updateProgress);
        }
      }

      video.addEventListener('play', () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateProgress);
      });

      video.addEventListener('pause', () => {
        cancelAnimationFrame(rafId);
      });

      video.addEventListener('ended', () => {
        cancelAnimationFrame(rafId);
        progressFill.style.width = '0%';
      });

      video.addEventListener('loadedmetadata', () => {
        progressFill.style.width = '0%';
      });
    }

    // Loop through all videos
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      const shouldAutoplay = () => (wrapper.closest('div.carousel-cell.is-selected'));

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster setup
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      var mtp = true;
      video.removeAttribute('muted');
      if (shouldAutoplay()) {
        var mtp = true;
        video.setAttribute('muted', '');
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.muted = mtp;

      function safePlay( clicked = false) {
        const carousel = section.querySelector('.customer-love-it__slider');
        const flkty = window.theme.Flickity.data(carousel);
        if (!flkty) return;
        const parentCell = video.closest('.carousel-cell');
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          const cellIndex = flkty.cells.findIndex(cell => cell.element === parentCell);
          if (cellIndex >= 0) flkty.select(cellIndex);
        }

        setTimeout(() => {
          console.log("clicked",clicked);
          if( clicked ){  
            if (muteBtn) muteBtn.classList.remove('muted');
            video.muted = false;
          }
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                playBtn?.classList.add('playing');
                video.onended = () => {
                  video.pause();
                  playBtn?.classList.remove('playing');
                  if (posterWrapper) posterWrapper.style.opacity = 1;
                  if (flkty) flkty.next();
                };
              })
              .catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }, 0);
      }

      video.addEventListener('playing', () => {
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });

      function pauseVideo(otherVideo = null, vWrapper = null) {
        if (otherVideo) {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        } else {
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        

        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }
        if (autoplay && video) {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('muted');
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';

        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              attachVideoProgress(video, wrapper); // ✅ attach progress bar
              if (autoplay) safePlay();
            }, { once: true });
          } else {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({
                  maxBufferLength: 3,
                  startLevel: -1,
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  attachVideoProgress(video, wrapper); // ✅ attach progress bar
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            attachVideoProgress(video, wrapper); // ✅ attach progress bar
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
      }

      // Observer logic
      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.customer_love_it_video');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);

          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos(wrapper);
          safePlay(true);
          video.muted = false;
          if (muteBtn) muteBtn.classList.remove('muted');
        } else {
          if (muteBtn) muteBtn.classList.add('muted');
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  function initCustomerLoverItSlider(section) {
    
    const slider = section.querySelector(".customer-love-it__slider");
    const desktop  = parseInt(slider.dataset.slidesDesktop) || 3;
    const tablet   = parseInt(slider.dataset.slidesTablet)  || 2;
    const mobile   = parseInt(slider.dataset.slidesMobile)  || 1;
    const autoPlay = false;
    const nav   = slider.dataset.showNav == "true";
    const totalSlides = slider.querySelectorAll(".carousel-cell").length;

    function alignment(){
      if (window.innerWidth > 1024) return 'center';
      if (window.innerWidth >= 768)  return 'center';
      return 'left';
    }
    function getGroupCells(){
      if (window.innerWidth > 1024) return desktop;
      if (window.innerWidth >= 768)  return tablet;
      return mobile;
    }
    function getOptions() {
      const slidesToShow = getGroupCells();
      const contain_v = totalSlides <= slidesToShow;
      const wrap_v    = totalSlides > slidesToShow;
      var truenav = false
      if( nav && wrap_v ){
        truenav = true; 
      }
      return {
        cellAlign: alignment(),
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: autoPlay > 0 ? autoPlay : false,
        prevNextButtons: truenav,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        adaptiveHeight: false,
      };
    }

    // init Flickity
    let flkty = new window.theme.Flickity(slider, getOptions());

    // reinit on resize if breakpoint changes
    let lastSlidesToShow = getGroupCells();
    let lastAlign = alignment();


    window.addEventListener("resize", () => {
      const newSlidesToShow = getGroupCells();
      const newAlign = alignment();

      if (newSlidesToShow !== lastSlidesToShow || newAlign !== lastAlign) {
        flkty.destroy();
        flkty = new window.theme.Flickity(slider, getOptions());
        lastSlidesToShow = newSlidesToShow;
        lastAlign = newAlign;
      } else {
        flkty.resize();
      }
    });

    // flkty.on('settle', () => {
    //   const currentCell = flkty.selectedElement;
    //   const video_wrapper = currentCell?.querySelector('.customer_love_it_video');
    //   if (video_wrapper) {
    //     safePlayUsingFlickity(section, video_wrapper);
    //   }
    // });
    // Fires immediately when slide changes
    flkty.on('change', (index) => {
      const allVideos = section.querySelectorAll('.customer_love_it_video');

      // Pause all videos immediately
      allVideos.forEach((videoWrapper) => {
        const video = videoWrapper.querySelector('video');
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0; // optional: reset to start
        }
      });

      // Play video in the new slide after change
      const currentCell = flkty.cells[index].element;
      const currentVideoWrapper = currentCell.querySelector('.customer_love_it_video');
      const playBtn = currentCell.querySelector('.glb_play');

      if (currentVideoWrapper) {
        //playBtn.click();
        //safePlayUsingFlickity(section, currentVideoWrapper);
      }
    });

  }
  document.querySelectorAll(".customer-love-it").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomerLoverItHlsVideo(sectionID);
    initCustomerLoverItSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".customer-love-it");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomerLoverItHlsVideo(sectionID);
      initCustomerLoverItSlider(section);
    }
  });
  
  // 🔧 Customizer events
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    if (section.classList.contains("customer-love-it")) {
      initCustomerLoveIt(section);
    }
  });
  
})();


